import {IComponentController, IComponentOptions, IScope} from "angular";
import {CustomerFilter} from "../../../customers/model/CustomerFilter";

export enum LoanPurpose {
    PURCHASE = "Purchase",
    REFINANCE = "Refinance (Rate/Term)",
    REFINANCE_CASHOUT = "Refinance (Cash Out)",
    CONSTRUCTION = "Construction",
    CONSTRUCTION_PERM = "Construction Perm",
    FHA = "FHA Streamline Refi",
    VA_IRRRL = "VA IRRRL",
    OTHER = "Other",
    HELOC = "HELOC",
    UNKNOWN = "Unknown"
}

interface LoanPurposeFilterComponentScope extends IScope {
    allPurposes: LoanPurpose[]
    filter: CustomerFilter;
}

export class LoanPurposeFilterComponent implements IComponentController {

    public static instance: IComponentOptions = {
        template: require('./LoanPurpouseFilterComponent.html'),
        controller: ['$scope', LoanPurposeFilterComponent],
        bindings: {
            filter: '='
        }
    };

    private $scope: LoanPurposeFilterComponentScope;
    private filter: CustomerFilter;

    constructor($scope: LoanPurposeFilterComponentScope) {
        $scope.allPurposes = Object.values(LoanPurpose);
        this.$scope = $scope;
    }

    $onInit(): void {
        this.$scope.filter = this.filter;
    }


}